import React from "react";
import '../../../styles/Projects.css';
import proImage from '../../../assets/images/subvuln.png';
import passGen from '../../../assets/images/passwordGen.png';
import basicPortFolio from '../../../assets/images/basicPortfolio.png';
import bootstrapPortFolio from '../../../assets/images/bootStrapPortFolio.png';


const ProjectDetails = ({ projectName, projectOverview, projectImage }) => {
    return (
        <div className="myProject">
            <div className="projectDetails">
                <div className="projectImage">
                    <img src={projectImage} alt="Project Image" />
                </div>
                <div className="projectName">
                    <h3>{projectName}</h3>
                </div>
                <div className="projectOverview">
                    <p>{projectOverview}</p>
                </div>
                <div className="projectButton">
                <button >Show More</button>
                <button>Demo</button>
            </div>
            </div>
        </div>
    )
}

const Project = () => {
    return (
        <>
            <div className="projectContainer">
                <h2>My Projects</h2>
                <div className="projects">
                    <ProjectDetails projectName={"SubVuln"} projectImage={proImage} projectOverview={"Built a subdomain vulnerability finder project using Subfinder, Subzy, Linux, HTTPX, and Bash script. Automated the workflow with Bash script for subdomain enumeration, subdomain takeover detection, and HTTPS scanning"} />
                    <ProjectDetails projectName={"Password Generator"} projectImage={passGen} projectOverview={"Created a password generator with HTML, CSS, and JavaScript, showcasing front-end skills and user-friendly app creation. Applied JavaScript's randomization methods for generating secure passwords based on user-defined criteria, including length and character types. length and character types."} />
                    <ProjectDetails projectName={"Portfolio using HTML, CSS, JS"} projectImage={basicPortFolio} projectOverview={"Engineered a responsive personal portfolio webpage through the utilization of HTML, CSS, and JavaScript. Implemented a fully responsive design for the website, optimizing it for both desktop and mobile devices. Achieved a visually consistent and aesthetically pleasing design through the strategic use of CSS styling and layout techniques."} />
                    <ProjectDetails projectName={"Portfolio using Bootstrap"} projectImage={bootstrapPortFolio} projectOverview={"Engineered a responsive personal portfolio webpage through the utilization of HTML, CSS, BootStrap. Implemented a fully responsive design for the website, optimizing it for both desktop and mobile devices. Achieved a visually consistent and aesthetically pleasing design through the strategic use of CSS styling and layout techniques."} />
                </div>
            </div>
            </>
    )
}

export default Project;